<template>
  <div class="parent_div">
    <dd-header />
    <h2 class="hakotan_title">商品を選ぶ</h2>
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <section class="select_category">
            <div class="product_search_cond">
              <div class="product_search_act_square">
                <div>現在の検索条件:{{searchCond}}</div>
                <div class="product_search_count">該当商品 {{productCnt}}件</div>
              </div>
              <div class="product_button">
                <div @click="onSearch" class="square_btn_black">絞り込む</div>
                <div @click="onReset" class="square_btn_white">条件リセット</div>
              </div>
            </div>
          </section>
          <section id="product_list" ref="product_top" v-if="productList.length > 0" v-cloak>
            <div v-for="(product, index) in productList" class="product" :key="'product-' + index" :value="product" @click="customize(product)">
              <img :src="getImage(product.dcFdImage)">
              <div class="product_detail">
                <div>
                  <p class="bold">{{product.dcFdName}}</p>
                  <p class="pickup bold">{{productSize(product.dcMinWidth, product.dcMaxWidth)}}</p>
                </div>
              </div>
            </div>
          </section>
          <dd-pager
            :pageNo="pageNo"
            :dataCountPerPage="18"
            :totalDataCount="dcFileDataList.length"
            @paging="paging"
          />
          <div v-if="dcFileDataList.length <= 0">該当する商品がありません。</div>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'

import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as AppEc from '../utils/AppEc'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcPager from '../components/common/DcPager'

const PRODUCT_VIEW_SIZE = 18

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-loading-modal': LoadingModal,
    'dd-pager': DcPager
  },
  data () {
    return {
      pageKey: 'dcCategory',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'category', key: 'dcCategory', title: '商品を選ぶ', route: 'DcCategory'}
      ],
      // selectedCategory: 1,
      selCategoryData: {},
      dcFileDataList: [],
      // selCategoryNo: 1,
      categoryList: [],
      pageNo: 1,
      // businessDataList: [],
      searchForm: {},
      productCnt: 0,
      searchCond: '条件なし',
      scrollVisible: false
    }
  },
  computed: {
    // 表示用商品リスト
    productList: function () {
      let startIdx = (this.pageNo - 1) * PRODUCT_VIEW_SIZE
      let endIdx = this.pageNo * PRODUCT_VIEW_SIZE
      let list = this.dcFileDataList.filter(function (element, index) {
        return (index >= startIdx && index < endIdx)
      })
      return list
    }
  },
  methods: {
    syncLogin: async function () {
      await this.guestLogin()
      await this.getCategoryList()
      await this.init()
    },
    guestLogin: async function () {
      this.$refs.loadingModalRef.showModal(true)
      await axios.get(DC_URL.LOGIN + '/guest')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.userInfo = response.data.data
            console.log('set guest user:' + Object.entries(this.userInfo))
            App.setLocalStorage(DC_STORAGE_KEY.USER_INFO, this.userInfo)
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    init: function () {
      this.$refs.loadingModalRef.showModal(true)
      let _this = this
      axios.get(DC_URL.TOP + '/init')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.categoryList = response.data.data
            let categoryIdList
            if (this.categoryList !== undefined) {
              categoryIdList = this.$route.query.cid !== undefined ? _this.categoryList.filter(c => String(_this.$route.query.cid).split('_').map(Number).includes(c.id)).map(c => c.id) : undefined
            }
            this.searchForm = {
              categoryList: categoryIdList !== undefined ? categoryIdList : [],
              minWidth: this.$route.query.min_w,
              maxWidth: this.$route.query.max_w,
              minHeight: this.$route.query.min_h,
              maxHeight: this.$route.query.max_h,
              minDepth: this.$route.query.min_d,
              maxDepth: this.$route.query.max_d,
              makerIdList: this.$route.query.maker_id !== undefined ? String(this.$route.query.maker_id).split('_') : []
            }
            this.searchCond = this.saveSearchCond(this.searchForm)
            this.search(this.searchForm)
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    convertDcFileData: function (data) {
      let dcFileData = {
        dcFdId: data.dcFdId,
        dcCategoryType: data.dcCategoryType,
        dcFdType: data.dcFdType,
        dcFdName: data.dcFdName,
        dcFileName: data.dcFileName,
        seriesName: data.seriesName,
        dcFdImage: data.dcFdImage,
        dcFdImageB: this.bigImage(data.dcFdImage),
        dcWidth: data.defW,
        dcMinWidth: data.minW,
        dcMaxWidth: data.maxW,
        dcHeight: data.defH,
        dcMinHeight: data.minH,
        dcMaxHeight: data.maxH,
        dcDepth: data.defD,
        dcMinDepth: data.minD,
        dcMaxDepth: data.maxD,
        dcHeight2: data.defH2,
        dcMinHeight2: data.minH2,
        dcMaxHeight2: data.maxH2,
        dcDepth2: data.defD2,
        dcMinDepth2: data.minD2,
        dcMaxDepth2: data.maxD2,
        dcBType: data.btype,
        dcBSize: data.bsize,
        dcCType: data.ctype,
        dcCSize: data.csize,
        dcDType: data.dtype,
        dcDSize: data.dsize,
        dcProductCount: 1,
        dcBTypeDisableFlg: data.btypeDisableFlg,
        dcCTypeDisableFlg: data.ctypeDisableFlg,
        dcDTypeDisableFlg: data.dtypeDisableFlg,
        opShelfDisableFlg: data.opShelfDisableFlg,
        opFillerDisableFlg: data.opFillerDisableFlg,
        opShelfType: data.opShelfType,
        opFillerType: data.opFillerType,
        corpData: data.corpData,
        inputReferenceList: data.inputReferenceList,
        cDcProductManual: data.dcProductManual,
        cDcConstructManual: data.dcConstructManual,
        cDcUserManual: data.dcUserManual,
        categoryImg: data.categoryImg,
        categoryName: data.categoryName
      }
      return dcFileData
    },
    getCategoryList: async function () {
      await axios.get(DC_URL.TOP + '/category')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          }
          this.categoryList = response.data.data
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    bigImage: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return file + '_B' + exp
    },
    categoryImgBlack: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return this.getImage('category/' + file + '_black' + exp)
    },
    categoryImgWhite: function (imgName) {
      if (!imgName) return undefined
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return this.getImage('category/' + file + '_white' + exp)
    },
    // selectCategory: function (category) {
    // // ページ数を戻す
    //  this.pageNo = 1
    // // カテゴリ変更処理
    //  this.selCategoryData = category
    //  this.init(this.selCategoryData.id)
    //  this.errors = {}
    //  this.$forceUpdate()
    // },
    productSize: function (min, max) {
      return ('幅' + min + ' ～ ' + max + 'mm')
    },
    paging: function (currentPageNo) {
      this.pageNo = currentPageNo
      this.scrollToAnchorPoint('product_top')
    },
    customize: function (product) {
      this.$router.push({
        name: 'DcCustomize',
        query: {id: product.dcFdId, ctype: product.dcCategoryType, dtype: product.dcFdType}
      })
    },
    scrollToAnchorPoint: function (refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({behavior: 'auto'})
    },
    categoryName: function (name) {
      if (!name) return ''
      console.log('param:' + name)
      const s = name.replace('（', '\n（')
      console.log(s)
      return s
    },
    onSearch: function () {
      let modalData = {
        paramsForm: this.searchForm,
        categoryList: this.categoryList,
        onOk: (callback) => {
          this.searchCond = this.saveSearchCond(callback)
          this.settingOfQuery(callback)
          document.body.style.overflow = 'scroll'
          let payload = {
            categoryList: callback.categoryList.map(c => c.id),
            minWidth: callback.minWidth,
            maxWidth: callback.maxWidth,
            minHeight: callback.minHeight,
            maxHeight: callback.maxHeight,
            minDepth: callback.minDepth,
            maxDepth: callback.maxDepth,
            makerIdList: callback.makerIdList
          }
          this.search(payload)
        },
        onCancel: (callback) => {
          document.body.style.overflow = 'scroll'
        },
        callbackParams: {}
      }
      AppEc.showProductSearch(modalData)
      document.body.style.overflow = 'hidden'
    },
    onReset: function () {
      this.deleteQuery()
      let payload = {
        categoryList: undefined,
        minWidth: undefined,
        maxWidth: undefined,
        minHeight: undefined,
        maxHeight: undefined,
        minDepth: undefined,
        maxDepth: undefined,
        makerIdList: undefined
      }
      this.searchCond = '条件なし'
      this.search(payload)
    },
    search: function (payload) {
      this.$refs.loadingModalRef.showModal(true)
      axios.post(DC_URL.TOP + '/product-search', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.dcFileDataList = []
            this.productCnt = 0
            response.data.data
              .forEach(f => {
                let dcFileData = this.convertDcFileData(f)
                this.dcFileDataList.push(dcFileData)
              })
            this.pageNo = 1
            this.productCnt = this.dcFileDataList.length
          }
          this.$refs.loadingModalRef.showModal(false)
        }).catch(error => {
          Api.handleError(error)
          this.modalShown = false
          this.$refs.loadingModalRef.showModal(false)
        }).finally(() => {
        })
    },
    saveSearchCond: function (callback) {
      let searchCondList = []
      if (callback.categoryList) {
        callback.categoryList
          .forEach(id => {
            searchCondList.push(this.categoryList.filter(c => c.id === id).map(c => c.name))
          })
      }
      if (callback) {
        if (callback.minWidth && callback.maxWidth) {
          searchCondList.push('幅:' + callback.minWidth + 'mm ～ ' + callback.maxWidth + 'mm')
        } else if (callback.minWidth) {
          searchCondList.push('幅:' + callback.minWidth + 'mm')
        } else if (callback.maxWidth) {
          searchCondList.push('幅: ～ ' + callback.maxWidth + 'mm')
        }
        if (callback.minHeight && callback.maxHeight) {
          searchCondList.push('高さ:' + callback.minHeight + 'mm ～ ' + callback.maxHeight + 'mm')
        } else if (callback.minHeight) {
          searchCondList.push('高さ:' + callback.minHeight + 'mm')
        } else if (callback.maxHeight) {
          searchCondList.push('高さ: ～ ' + callback.maxHeight + 'mm')
        }
        if (callback.minDepth && callback.maxDepth) {
          searchCondList.push('奥行き:' + callback.minDepth + 'mm ～ ' + callback.maxDepth + 'mm')
        } else if (callback.minDepth) {
          searchCondList.push('奥行き:' + callback.minDepth + 'mm')
        } else if (callback.maxDepth) {
          searchCondList.push('奥行き: ～ ' + callback.maxDepth + 'mm')
        }
      }
      if (callback.makerIdList) {
        callback.makerIdList
          .forEach(m => {
            if (m === 10000) searchCondList.push('株式会社アクシス')
            if (m === 10001) searchCondList.push('株式会社テクマ')
            if (m === 27) searchCondList.push('ファニチャーメーカー')
            if (m === 1001) searchCondList.push('株式会社みうら')
            if (m === 300) searchCondList.push('ドゥーマンズ株式会社')
          })
      }
      if (searchCondList.length <= 0) return '条件なし'
      return searchCondList.join('、')
    },
    settingOfQuery: function (callback) {
      let query = {}
      if (callback.categoryList && callback.categoryList.length > 0) {
        query.cid = callback.categoryList.map(c => c.id).join('_')
      }
      if (callback) {
        if (callback.minWidth) {
          query.min_w = callback.minWidth
        } else if (callback.maxWidth) {
          query.max_w = callback.maxWidth
        }
        if (callback.minHeight) {
          query.min_h = callback.minHeight
        } else if (callback.maxHeight) {
          query.max_h = callback.maxHeight
        }
        if (callback.minDepth) {
          query.min_d = callback.minDepth
        } else if (callback.maxDepth) {
          query.min_d = callback.maxDepth
        }
      }
      if (callback.makerIdList && callback.makerIdList.length > 0) {
        query.maker_id = callback.makerIdList.join('_')
      }
      this.$router.push({
        name: 'DcCategory',
        query: query
      })
    },
    handleScroll: function () {
      this.scrollY = window.scrollY
      if (!this.scrollVisible) {
        this.scrollVisible = window.scrollY > 500
      } else if (window.scrollY < 490) {
        this.scrollVisible = !this.scrollVisible
      }
    },
    deleteQuery: function () {
      var query = {}
      this.$router.push({query: query})
    }
  },
  watch: {
    $route (to, from) {
      this.init()
    }
  },
  mounted: function () {
    // カテゴリ
    document.body.style.overflow = 'scroll'
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.syncLogin()
    App.removeLocalStorage(DC_STORAGE_KEY.SAVE_PLAN)
    window.addEventListener('scroll', this.handleScroll)
  },
  created: function () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcCategory.vue